module.exports = __webpack_public_path__ + "img/V-63-ER-1000-BE.ebbcfaf9.png";